import { Link, useLocation } from 'react-router-dom';
import { Home, CalendarDays, Clock, ListChecks, User } from 'lucide-react';
import { useTranslation } from '../../../i18n';

export function MobileTabbar() {
  const { t } = useTranslation('navigation');
  const location = useLocation();

  const items = [
    { to: '/', label: t('menu.dashboard', { defaultValue: 'Start' }), icon: Home },
    { to: '/my-plan', label: t('menu.myPlan', { defaultValue: 'Plan' }), icon: CalendarDays },
    {
      to: '/my-checklists',
      label: t('menu.myChecklistsShort', { defaultValue: 'Checks' }),
      icon: ListChecks,
    },
    { to: '/timeclock', label: t('menu.timeclock', { defaultValue: 'Zeit' }), icon: Clock },
    { to: '/profile', label: t('menu.profile', { defaultValue: 'Profil' }), icon: User },
  ];

  return (
    <nav
      className="md:hidden fixed inset-x-0 bottom-0 z-40 bg-surface/95 dark:bg-slate-900/95 border-t border-border dark:border-slate-700 backdrop-blur"
      aria-label="Mobile navigation"
    >
      <ul className="grid grid-cols-5">
        {items.map(({ to, label, icon: Icon }) => {
          const isActive = location.pathname === to;
          return (
            <li key={to}>
              <Link
                to={to}
                className={`flex flex-col items-center justify-center gap-0.5 py-2.5 text-[10px] font-medium transition-colors ${
                  isActive
                    ? 'text-primary'
                    : 'text-ink-muted hover:text-ink dark:text-slate-400 dark:hover:text-slate-100'
                }`}
              >
                <Icon className="w-5 h-5" aria-hidden />
                <span>{label}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
